/**
 * Client-side mirror of `apps/api/src/modules/customers/domain/cuit.ts`, for
 * fast inline feedback only. The server re-validates on every write and is
 * the sole authority on whether a CUIT is actually valid.
 */

const CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

export function normalizeTaxId(raw: string): string {
  return raw.replace(/\D/g, '');
}

export function isValidTaxId(digits: string): boolean {
  if (!/^\d{11}$/.test(digits)) {
    return false;
  }

  const base = digits.slice(0, 10).split('').map(Number);
  const providedCheckDigit = Number(digits[10]);
  const sum = CHECK_DIGIT_WEIGHTS.reduce(
    (acc, weight, index) => acc + weight * (base[index] ?? 0),
    0,
  );
  const result = 11 - (sum % 11);

  if (result === 10) {
    return false;
  }

  const expectedCheckDigit = result === 11 ? 0 : result;
  return expectedCheckDigit === providedCheckDigit;
}
